import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import { makeStyles } from '@material-ui/core/styles'
import { SlugWrapper } from 'components/coaches-profile/profile-stepper.styles'
import {
  getFieldProps,
  requiredLabel,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

const useStyles = makeStyles(theme => ({
  adornment: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    marginRight: 0,
    '& p': {
      margin: 0,
    },
  },
}))

export default function CustomSlug({
  newProfile,
  fullWidth = false,
  label,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
}) {
  const inputRef = useRef()
  const classes = useCreateProfileFieldStyles()
  const adornmentClasses = useStyles()
  const fieldProps = getFieldProps(classes)
  const fieldLabel =
    label || (newProfile ? requiredLabel('Profile Name') : 'Profile Name')

  const textField = (
    <TextField
      {...fieldProps}
      name="customSlug"
      type="text"
      label={fieldLabel}
      value={values.customSlug || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      error={Boolean(errors?.customSlug)}
      helperText={errors?.customSlug?.message}
      inputRef={inputRef}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            className={`input-adornment ${adornmentClasses.adornment}`}
          >
            www.pga.com/coach/
          </InputAdornment>
        ),
      }}
    />
  )

  return newProfile ? (
    fullWidth ? (
      textField
    ) : (
      <SlugWrapper onClick={() => inputRef && inputRef.current.focus()}>
        {textField}
      </SlugWrapper>
    )
  ) : (
    <SlugWrapper>
      <TextField
        {...fieldProps}
        name="customSlug"
        label="Profile Name"
        type="text"
        value={values.customSlug}
        disabled
        error={touched.customSlug && errors.customSlug}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className="input-adornment">
              www.pga.com/coach/
            </InputAdornment>
          ),
        }}
      />
    </SlugWrapper>
  )
}

CustomSlug.propTypes = {
  newProfile: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
}
